import React, { useEffect, useRef } from 'react'
import { MapContainer, TileLayer, useMapEvents, useMap } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'

const toLatLng = (coord) => {
  if (!coord) return [35.729054, 51.42047]
  if (Array.isArray(coord)) return coord
  return [coord.lat, coord.lng]
}

function MapController({ center, onClick, onDrag }) {
  const prevCenter = useRef(null)

  const map = useMapEvents({
    click(e) {
      onClick && onClick(e.latlng)
    },
    drag() {
      onDrag && onDrag(map.getCenter())
    },
  })

  useEffect(() => {
    if (!center) return
    const [lat, lng] = toLatLng(center)
    if (prevCenter.current?.lat === lat && prevCenter.current?.lng === lng) return
    prevCenter.current = { lat, lng }
    map.setView([lat, lng])
  }, [center])

  return null
}

function LocateButton({ onClick }) {
  const map = useMap()

  const handleLocate = () => {
    if (!navigator.geolocation) return
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const latlng = { lat: pos.coords.latitude, lng: pos.coords.longitude }
        map.flyTo([latlng.lat, latlng.lng], 15)
        onClick && onClick(latlng)
      },
      () => {},
    )
  }

  return (
    <div
      style={{
        position: 'absolute',
        bottom: 20,
        right: 10,
        zIndex: 1000,
      }}
    >
      <button
        onClick={handleLocate}
        style={{
          background: '#fff',
          border: '2px solid rgba(0,0,0,0.2)',
          borderRadius: 4,
          width: 34,
          height: 34,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 1px 5px rgba(0,0,0,0.2)',
        }}
        title="موقعیت من"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#333"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="3" />
          <path d="M12 2v3M12 19v3M2 12h3M19 12h3" />
          <circle cx="12" cy="12" r="8" />
        </svg>
      </button>
    </div>
  )
}

const Map = ({ center, zoom, onClick, onDrag, containerStyle, children }) => {
  const zoomLevel = Array.isArray(zoom) ? zoom[0] : zoom || 13
  const latlng = toLatLng(center)

  return (
    <MapContainer
      center={latlng}
      zoom={zoomLevel}
      style={{ width: '100%', height: '100%', ...containerStyle }}
      zoomControl={true}
    >
      <TileLayer
        attribution='&copy; <a href="https://codarx.com">Codarx</a>'
        url="https://osm.pspegah.com/styles/basic/512/{z}/{x}/{y}.png"
      />
      <MapController center={center} onClick={onClick} onDrag={onDrag} />
      <LocateButton onClick={onClick} />
      {children}
    </MapContainer>
  )
}

export default Map
